import { API_URLS } from "../../constants";
import axios from "axios";

export const getScanStageReportDetails = async (scanStageId) => {
  try {
    const response = await axios.get(
      `${API_URLS.PUBLIC_REPORT.GET_SCAN_STAGE_REPORT}/${scanStageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching scan stage report details:", error);
    throw error;
  }
};

// api.js - add this new function
export const getContainerLocationDetails = async (locationId) => {
  try {
    const response = await axios.get(
      `${API_URLS.PUBLIC_REPORT.GET_CONTAINER_LOCATION}/${locationId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching container location details:", error);
    throw error;
  }
};

export const getScanPdf = async (scanId, stageName) => {
  try {
    const response = await axios.post(
      API_URLS.PUBLIC_REPORT.GET_SCAN_PDF,
      { scan_id: scanId, stage_name: stageName },
      { responseType: "blob" }
    );

    const blob = new Blob([response.data], { type: "application/pdf" });
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = `scan_${scanId}_${stageName}.pdf`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);

    return response;
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const getScanImagesZip = async (scanStageId) => {
  try {
    const response = await axios.get(
      `${API_URLS.PUBLIC_REPORT.GET_SCAN_IMAGES_ZIP}/${scanStageId}`
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching scan images ZIP:", error);
    throw error;
  }
};